import { render, staticRenderFns } from "./CartRecapitulation.vue?vue&type=template&id=65b46e44&"
import script from "./CartRecapitulation.vue?vue&type=script&lang=js&"
export * from "./CartRecapitulation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports